function KnifeShapeAccordion() {
    var selectedShapeState = React.useState(null);
    var selectedShape = selectedShapeState[0];
    var setSelectedShape = selectedShapeState[1];
    
    var expandedState = React.useState(true);
    var expanded = expandedState[0];
    var setExpanded = expandedState[1];
    
    var loadingState = React.useState(true);
    var loading = loadingState[0];
    var setLoading = loadingState[1];
    
    var knifeShapesState = React.useState([]);
    var knifeShapes = knifeShapesState[0];
    var setKnifeShapes = knifeShapesState[1];
    
    var filteredShapesState = React.useState([]);
    var filteredShapes = filteredShapesState[0];
    var setFilteredShapes = filteredShapesState[1];
    
    var hasLoadedState = React.useState(false);
    var hasLoaded = hasLoadedState[0];
    var setHasLoaded = hasLoadedState[1];
    
    var activeAccordionState = React.useState('shape');
    var activeAccordion = activeAccordionState[0];
    var setActiveAccordion = activeAccordionState[1];
    
    var popupOpenState = React.useState(false);
    var popupOpen = popupOpenState[0];
    var setPopupOpen = popupOpenState[1];
    
    var popupProductState = React.useState(null);
    var popupProduct = popupProductState[0];
    var setPopupProduct = popupProductState[1];
    
    var currentHandleFilterState = React.useState(null);
    var currentHandleFilter = currentHandleFilterState[0];
    var setCurrentHandleFilter = currentHandleFilterState[1];
    
    var accordionContentRef = React.useRef(null);
    
    React.useEffect(function() {
        window.KnifeCustomizationState.selectedShape = selectedShape;
        window.KnifeCustomizationState.setSelectedShape = setSelectedShape;
        window.KnifeCustomizationState.allShapes = knifeShapes;
    }, [selectedShape, knifeShapes]);
    
    React.useEffect(function() {
        setLoading(true);
        setKnifeShapes(mockKnifeShapes);
        setFilteredShapes(mockKnifeShapes);
        setLoading(false);
        setHasLoaded(true);
    }, []);
    
    React.useEffect(function() {
        var checkState = setInterval(function() {
            if (window.KnifeCustomizationState.activeAccordion !== activeAccordion) {
                setActiveAccordion(window.KnifeCustomizationState.activeAccordion);
                if (window.KnifeCustomizationState.activeAccordion !== 'shape') {
                    setExpanded(false);
                }
            }
            if (window.KnifeCustomizationState.selectedShape !== selectedShape) {
                setSelectedShape(window.KnifeCustomizationState.selectedShape);
            }
            
            var currentHandle = window.KnifeCustomizationState.selectedHandleData;
            var handleId = currentHandle ? currentHandle.id : null;
            
            if (handleId !== currentHandleFilter) {
                setCurrentHandleFilter(handleId);
                
                if (currentHandle) {
                    var compatibleShapes = getCompatibleShapesFromHandle(currentHandle);
                    if (compatibleShapes.length > 0) {
                        var filtered = knifeShapes.filter(function(shape) {
                            return compatibleShapes.includes(shape.id);
                        });
                        setFilteredShapes(filtered);
                        
                        if (selectedShape && !compatibleShapes.includes(selectedShape)) {
                            setSelectedShape(null);
                            window.KnifeCustomizationState.selectedShape = null;
                        }
                    } else {
                        setFilteredShapes(knifeShapes);
                    }
                } else {
                    setFilteredShapes(knifeShapes);
                }
                
                if (accordionContentRef.current) {
                    accordionContentRef.current.scrollTop = 0;
                }
            }
        }, 50);
        return function() { clearInterval(checkState); };
    }, [activeAccordion, selectedShape, knifeShapes, currentHandleFilter]);
    
    function handleShapeSelect(shapeId) {
        setSelectedShape(shapeId);
        window.KnifeCustomizationState.selectedShape = shapeId;
        
        if (shapeId === null) {
            window.KnifeCustomizationState.selectedBlade = null;
            window.KnifeCustomizationState.selectedBladeData = null;
            if (window.KnifeCustomizationState.setSelectedBlade) {
                window.KnifeCustomizationState.setSelectedBlade(null);
            }
        } else {
            var currentBlade = window.KnifeCustomizationState.selectedBladeData;
            if (currentBlade && !bladeMatchesShape(currentBlade, shapeId)) {
                window.KnifeCustomizationState.selectedBlade = null;
                window.KnifeCustomizationState.selectedBladeData = null;
                if (window.KnifeCustomizationState.setSelectedBlade) {
                    window.KnifeCustomizationState.setSelectedBlade(null);
                }
            }
            
            var currentHandle = window.KnifeCustomizationState.selectedHandleData;
            if (currentHandle && !handleFitsShape(currentHandle, shapeId)) {
                window.KnifeCustomizationState.selectedHandle = null;
                window.KnifeCustomizationState.selectedHandleData = null;
                if (window.KnifeCustomizationState.setSelectedHandle) {
                    window.KnifeCustomizationState.setSelectedHandle(null);
                }
            }
        }
    }
    
    function handleTooltipClick(e, shape) {
        e.stopPropagation();
        setPopupProduct(shape);
        setPopupOpen(true);
    }
    
    function toggleAccordion() {
        var newExpanded = !expanded;
        if (newExpanded) {
            window.KnifeCustomizationState.activeAccordion = 'shape';
            setActiveAccordion('shape');
        } else {
            window.KnifeCustomizationState.activeAccordion = null;
            setActiveAccordion(null);
        }
        setExpanded(newExpanded);
    }
    
    function handleReset(e) {
        e.stopPropagation();
        handleShapeSelect(null);
        if (accordionContentRef.current) {
            accordionContentRef.current.scrollTop = 0;
        }
    }
    
    var selectedShapeName = selectedShape ? (function() {
        var found = filteredShapes.find(function(s) { return s.id === selectedShape; });
        return found ? found.name : null;
    })() : null;
    
    function getShapeImage(shape) {
        return shapeImages[shape.id] || shape.image || '';
    }
    
    return React.createElement(React.Fragment, null,
        React.createElement('div', { className: 'knife-accordion' },
            React.createElement('div', { className: 'customization--option-dropdown', onClick: toggleAccordion },
                React.createElement('div', { className: 'customization--option-left' },
                    React.createElement('img', { src: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/Accordion-icon-shape.svg?v=1769763716', loading: 'lazy', width: '174', alt: '', className: 'customization-icon' }),
                    React.createElement('div', { className: 'customization--option-text' }, 'Select Your Knife Shape', selectedShapeName && ' - ' + selectedShapeName)
                ),
                React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d5f61874fb14ff18f15d86_customization-icon-right.svg', loading: 'lazy', alt: '', className: 'image' })
            ),
            React.createElement('div', { className: 'accordion-content' + (expanded ? ' expanded' : ''), ref: accordionContentRef },
                React.createElement('div', { className: 'reset-button-container' + (selectedShape && !loading ? ' visible' : '') },
                    React.createElement('div', { className: 'reset-button-inner' },
                        React.createElement('div', { className: 'reset-button', onClick: handleReset },
                            React.createElement('div', { className: 'reset--button-text' }, 'RESET SELECTION'),
                            React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d64cf53de35dba15bd1f53_9ca7e0fa65307fe51373378192d8b7ee_reset-icon.svg', loading: 'lazy', width: 'Auto', alt: '', className: 'reset--button-icon' })
                        )
                    )
                ),
                React.createElement('div', { className: 'accordion-grid' },
                    loading ? React.createElement(SkeletonLoader, { count: 8 }) :
                    filteredShapes.length === 0 ?
                        React.createElement('div', { className: 'accordion-empty-state' }, 'No shapes available for selected handle') :
                    filteredShapes.map(function(shape) {
                        return React.createElement(ProductCard, {
                            key: shape.id,
                            product: shape,
                            isSelected: selectedShape === shape.id,
                            onSelect: handleShapeSelect,
                            onTooltipClick: handleTooltipClick,
                            showPrice: false,
                            getImageUrl: getShapeImage
                        });
                    })
                )
            )
        ),
        React.createElement(ProductPopup, { isOpen: popupOpen, onClose: function() { setPopupOpen(false); }, product: popupProduct, imageType: 'shape' })
    );
}

function BladeTypeAccordion() {
    var selectedBladeState = React.useState(null);
    var selectedBlade = selectedBladeState[0];
    var setSelectedBlade = selectedBladeState[1];
    
    var expandedState = React.useState(false);
    var expanded = expandedState[0];
    var setExpanded = expandedState[1];
    
    var loadingState = React.useState(false);
    var loading = loadingState[0];
    var setLoading = loadingState[1];
    
    var bladeTypesState = React.useState([]);
    var bladeTypes = bladeTypesState[0];
    var setBladeTypes = bladeTypesState[1];
    
    var allBladesState = React.useState([]);
    var allBlades = allBladesState[0];
    var setAllBlades = allBladesState[1];
    
    var hasLoadedAllState = React.useState(false);
    var hasLoadedAll = hasLoadedAllState[0];
    var setHasLoadedAll = hasLoadedAllState[1];
    
    var activeAccordionState = React.useState(null);
    var activeAccordion = activeAccordionState[0];
    var setActiveAccordion = activeAccordionState[1];
    
    var popupOpenState = React.useState(false);
    var popupOpen = popupOpenState[0];
    var setPopupOpen = popupOpenState[1];
    
    var popupProductState = React.useState(null);
    var popupProduct = popupProductState[0];
    var setPopupProduct = popupProductState[1];
    
    var currentFilterShapeState = React.useState(null);
    var currentFilterShape = currentFilterShapeState[0];
    var setCurrentFilterShape = currentFilterShapeState[1];
    
    var currentFilterHandleState = React.useState(null);
    var currentFilterHandle = currentFilterHandleState[0];
    var setCurrentFilterHandle = currentFilterHandleState[1];
    
    var accordionContentRef = React.useRef(null);
    
    React.useEffect(function() {
        window.KnifeCustomizationState.selectedBlade = selectedBlade;
        window.KnifeCustomizationState.setSelectedBlade = setSelectedBlade;
        window.KnifeCustomizationState.allBlades = allBlades;
    }, [selectedBlade, allBlades]);
    
    var filterBlades = React.useCallback(function(blades, shapeId, handleData) {
        var filtered = blades.slice();
        
        if (shapeId) {
            filtered = filtered.filter(function(blade) {
                return bladeMatchesShape(blade, shapeId);
            });
        } else if (handleData) {
            var compatibleShapes = getCompatibleShapesFromHandle(handleData);
            if (compatibleShapes.length > 0) {
                filtered = filtered.filter(function(blade) {
                    var bladeShape = getShapeFromBladeTags(blade.tags);
                    return bladeShape && compatibleShapes.includes(bladeShape);
                });
            }
        }
        
        if (handleData && handleHasBladeRestrictions(handleData)) {
            filtered = filtered.filter(function(blade) {
                return bladeFitsHandle(blade, handleData);
            });
        }
        
        return filtered;
    }, []);
    
    React.useEffect(function() {
        var checkState = setInterval(function() {
            if (window.KnifeCustomizationState.activeAccordion !== activeAccordion) {
                setActiveAccordion(window.KnifeCustomizationState.activeAccordion);
                if (window.KnifeCustomizationState.activeAccordion !== 'blade') {
                    setExpanded(false);
                }
            }
            
            var currentShape = window.KnifeCustomizationState.selectedShape;
            var currentHandle = window.KnifeCustomizationState.selectedHandleData;
            var handleId = currentHandle ? currentHandle.id : null;
            
            if (currentShape !== currentFilterShape || handleId !== currentFilterHandle) {
                setCurrentFilterShape(currentShape);
                setCurrentFilterHandle(handleId);
                
                if (hasLoadedAll && allBlades.length > 0) {
                    var filtered = filterBlades(allBlades, currentShape, currentHandle);
                    setBladeTypes(filtered);
                    
                    if (selectedBlade) {
                        var stillExists = filtered.some(function(b) { return b.id === selectedBlade; });
                        if (!stillExists) {
                            setSelectedBlade(null);
                            window.KnifeCustomizationState.selectedBlade = null;
                            window.KnifeCustomizationState.selectedBladeData = null;
                        }
                    }
                    
                    if (accordionContentRef.current) {
                        accordionContentRef.current.scrollTop = 0;
                    }
                }
            }
        }, 50);
        return function() { clearInterval(checkState); };
    }, [activeAccordion, currentFilterShape, currentFilterHandle, hasLoadedAll, allBlades, selectedBlade, filterBlades]);
    
    function handleBladeSelect(bladeId) {
        var blade = allBlades.find(function(b) { return b.id === bladeId; });
        setSelectedBlade(bladeId);
        window.KnifeCustomizationState.selectedBlade = bladeId;
        window.KnifeCustomizationState.selectedBladeData = blade || null;
        
        if (blade) {
            var shapeFromBlade = getShapeFromBladeTags(blade.tags);
            if (shapeFromBlade && shapeFromBlade !== window.KnifeCustomizationState.selectedShape) {
                window.KnifeCustomizationState.selectedShape = shapeFromBlade;
                if (window.KnifeCustomizationState.setSelectedShape) {
                    window.KnifeCustomizationState.setSelectedShape(shapeFromBlade);
                }
                setCurrentFilterShape(shapeFromBlade);
                
                var currentHandle = window.KnifeCustomizationState.selectedHandleData;
                if (currentHandle && !handleFitsShape(currentHandle, shapeFromBlade)) {
                    window.KnifeCustomizationState.selectedHandle = null;
                    window.KnifeCustomizationState.selectedHandleData = null;
                    if (window.KnifeCustomizationState.setSelectedHandle) {
                        window.KnifeCustomizationState.setSelectedHandle(null);
                    }
                }
            }
            
            var currentHandle = window.KnifeCustomizationState.selectedHandleData;
            if (currentHandle && !bladeFitsHandle(blade, currentHandle)) {
                window.KnifeCustomizationState.selectedHandle = null;
                window.KnifeCustomizationState.selectedHandleData = null;
                if (window.KnifeCustomizationState.setSelectedHandle) {
                    window.KnifeCustomizationState.setSelectedHandle(null);
                }
            }
        }
    }
    
    function handleTooltipClick(e, blade) {
        e.stopPropagation();
        setPopupProduct(blade);
        setPopupOpen(true);
    }
    
    function toggleAccordion() {
        var newExpanded = !expanded;
        if (newExpanded) {
            window.KnifeCustomizationState.activeAccordion = 'blade';
            setActiveAccordion('blade');
        } else {
            window.KnifeCustomizationState.activeAccordion = null;
            setActiveAccordion(null);
        }
        setExpanded(newExpanded);
        
        if (newExpanded && !hasLoadedAll) {
            setLoading(true);
            window.fetchProducts('blades').then(function(data) {
                setAllBlades(data);
                window.KnifeCustomizationState.allBlades = data;
                
                var currentShape = window.KnifeCustomizationState.selectedShape;
                var currentHandle = window.KnifeCustomizationState.selectedHandleData;
                var filtered = filterBlades(data, currentShape, currentHandle);
                setBladeTypes(filtered);
                
                setHasLoadedAll(true);
                setLoading(false);
            }).catch(function() {
                setBladeTypes([]);
                setAllBlades([]);
                setLoading(false);
            });
        }
    }
    
    function handleReset(e) {
        e.stopPropagation();
        setSelectedBlade(null);
        window.KnifeCustomizationState.selectedBlade = null;
        window.KnifeCustomizationState.selectedBladeData = null;
        window.KnifeCustomizationState.selectedShape = null;
        if (window.KnifeCustomizationState.setSelectedShape) {
            window.KnifeCustomizationState.setSelectedShape(null);
        }
        if (accordionContentRef.current) {
            accordionContentRef.current.scrollTop = 0;
        }
    }
    
    var selectedBladeName = selectedBlade ? (function() {
        var found = bladeTypes.find(function(b) { return b.id === selectedBlade; });
        return found ? found.name : null;
    })() : null;
    
    function getBladeImage(blade) {
        return (blade.metafields && blade.metafields['custom.customization_thumbnail']) || blade.image || '';
    }
    
    return React.createElement(React.Fragment, null,
        React.createElement('div', { className: 'knife-accordion' },
            React.createElement('div', { className: 'customization--option-dropdown', onClick: toggleAccordion },
                React.createElement('div', { className: 'customization--option-left' },
                    React.createElement('img', { src: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/Accordion-icon-blade.svg?v=1769763719', loading: 'lazy', width: '174', alt: '', className: 'customization-icon' }),
                    React.createElement('div', { className: 'customization--option-text' }, 'Select Your Blade Type', selectedBladeName && ' - ' + selectedBladeName)
                ),
                React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d5f61874fb14ff18f15d86_customization-icon-right.svg', loading: 'lazy', alt: '', className: 'image' })
            ),
            React.createElement('div', { className: 'accordion-content' + (expanded ? ' expanded' : ''), ref: accordionContentRef },
                React.createElement('div', { className: 'reset-button-container' + (selectedBlade && !loading ? ' visible' : '') },
                    React.createElement('div', { className: 'reset-button-inner' },
                        React.createElement('div', { className: 'reset-button', onClick: handleReset },
                            React.createElement('div', { className: 'reset--button-text' }, 'RESET SELECTION'),
                            React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d64cf53de35dba15bd1f53_9ca7e0fa65307fe51373378192d8b7ee_reset-icon.svg', loading: 'lazy', width: 'Auto', alt: '', className: 'reset--button-icon' })
                        )
                    )
                ),
                React.createElement('div', { className: 'accordion-grid' },
                    loading ? React.createElement(SkeletonLoader, { count: 4 }) :
                    bladeTypes.length === 0 ? 
                        React.createElement('div', { className: 'accordion-empty-state' }, 'No blade types available') :
                    bladeTypes.map(function(blade) {
                        return React.createElement(ProductCard, {
                            key: blade.id,
                            product: blade,
                            isSelected: selectedBlade === blade.id,
                            onSelect: handleBladeSelect,
                            onTooltipClick: handleTooltipClick,
                            showPrice: true,
                            getImageUrl: getBladeImage
                        });
                    })
                )
            )
        ),
        React.createElement(ProductPopup, { isOpen: popupOpen, onClose: function() { setPopupOpen(false); }, product: popupProduct, imageType: 'blade' })
    );
}

function HandleTypeAccordion() {
    var selectedHandleState = React.useState(null);
    var selectedHandle = selectedHandleState[0];
    var setSelectedHandle = selectedHandleState[1];
    
    var expandedState = React.useState(false);
    var expanded = expandedState[0];
    var setExpanded = expandedState[1];
    
    var loadingState = React.useState(false);
    var loading = loadingState[0];
    var setLoading = loadingState[1];
    
    var handleTypesState = React.useState([]);
    var handleTypes = handleTypesState[0];
    var setHandleTypes = handleTypesState[1];
    
    var allHandlesState = React.useState([]);
    var allHandles = allHandlesState[0];
    var setAllHandles = allHandlesState[1];
    
    var hasLoadedAllState = React.useState(false);
    var hasLoadedAll = hasLoadedAllState[0];
    var setHasLoadedAll = hasLoadedAllState[1];
    
    var activeAccordionState = React.useState(null);
    var activeAccordion = activeAccordionState[0];
    var setActiveAccordion = activeAccordionState[1];
    
    var popupOpenState = React.useState(false);
    var popupOpen = popupOpenState[0];
    var setPopupOpen = popupOpenState[1];
    
    var popupProductState = React.useState(null);
    var popupProduct = popupProductState[0];
    var setPopupProduct = popupProductState[1];
    
    var currentFilterShapeState = React.useState(null);
    var currentFilterShape = currentFilterShapeState[0];
    var setCurrentFilterShape = currentFilterShapeState[1];
    
    var currentFilterBladeState = React.useState(null);
    var currentFilterBlade = currentFilterBladeState[0];
    var setCurrentFilterBlade = currentFilterBladeState[1];
    
    var accordionContentRef = React.useRef(null);
    
    React.useEffect(function() {
        window.KnifeCustomizationState.selectedHandle = selectedHandle;
        window.KnifeCustomizationState.setSelectedHandle = setSelectedHandle;
        window.KnifeCustomizationState.allHandles = allHandles;
    }, [selectedHandle, allHandles]);
    
    var filterHandles = React.useCallback(function(handles, shapeId, bladeData) {
        var filtered = handles.slice();
        
        if (shapeId) {
            filtered = filtered.filter(function(handle) {
                return handleFitsShape(handle, shapeId);
            });
        }
        
        if (bladeData) {
            filtered = filtered.filter(function(handle) {
                return handleFitsBlade(handle, bladeData);
            });
        }
        
        return filtered;
    }, []);
    
    React.useEffect(function() {
        var checkState = setInterval(function() {
            if (window.KnifeCustomizationState.activeAccordion !== activeAccordion) {
                setActiveAccordion(window.KnifeCustomizationState.activeAccordion);
                if (window.KnifeCustomizationState.activeAccordion !== 'handle') {
                    setExpanded(false);
                }
            }
            
            var currentShape = window.KnifeCustomizationState.selectedShape;
            var currentBlade = window.KnifeCustomizationState.selectedBladeData;
            var bladeId = currentBlade ? currentBlade.id : null;
            
            if (currentShape !== currentFilterShape || bladeId !== currentFilterBlade) {
                setCurrentFilterShape(currentShape);
                setCurrentFilterBlade(bladeId);
                
                if (hasLoadedAll && allHandles.length > 0) {
                    var filtered = filterHandles(allHandles, currentShape, currentBlade);
                    setHandleTypes(filtered);
                    
                    if (selectedHandle) {
                        var stillExists = filtered.some(function(h) { return h.id === selectedHandle; });
                        if (!stillExists) {
                            setSelectedHandle(null);
                            window.KnifeCustomizationState.selectedHandle = null;
                            window.KnifeCustomizationState.selectedHandleData = null;
                        }
                    }
                    
                    if (accordionContentRef.current) {
                        accordionContentRef.current.scrollTop = 0;
                    }
                }
            }
        }, 50);
        return function() { clearInterval(checkState); };
    }, [activeAccordion, currentFilterShape, currentFilterBlade, hasLoadedAll, allHandles, selectedHandle, filterHandles]);
    
    function handleHandleSelect(handleId) {
        var handle = allHandles.find(function(h) { return h.id === handleId; });
        setSelectedHandle(handleId);
        window.KnifeCustomizationState.selectedHandle = handleId;
        window.KnifeCustomizationState.selectedHandleData = handle || null;
        
        if (handle) {
            var compatibleShapes = getCompatibleShapesFromHandle(handle);
            var currentShape = window.KnifeCustomizationState.selectedShape;
            
            if (currentShape && !compatibleShapes.includes(currentShape)) {
                window.KnifeCustomizationState.selectedShape = null;
                if (window.KnifeCustomizationState.setSelectedShape) {
                    window.KnifeCustomizationState.setSelectedShape(null);
                }
                
                var currentBlade = window.KnifeCustomizationState.selectedBladeData;
                if (currentBlade) {
                    var bladeShape = getShapeFromBladeTags(currentBlade.tags);
                    if (bladeShape && !compatibleShapes.includes(bladeShape)) {
                        window.KnifeCustomizationState.selectedBlade = null;
                        window.KnifeCustomizationState.selectedBladeData = null;
                        if (window.KnifeCustomizationState.setSelectedBlade) {
                            window.KnifeCustomizationState.setSelectedBlade(null);
                        }
                    }
                }
            } else {
                var currentBlade = window.KnifeCustomizationState.selectedBladeData;
                if (currentBlade) {
                    var bladeShape = getShapeFromBladeTags(currentBlade.tags);
                    if (bladeShape && !compatibleShapes.includes(bladeShape)) {
                        window.KnifeCustomizationState.selectedBlade = null;
                        window.KnifeCustomizationState.selectedBladeData = null;
                        window.KnifeCustomizationState.selectedShape = null;
                        if (window.KnifeCustomizationState.setSelectedBlade) {
                            window.KnifeCustomizationState.setSelectedBlade(null);
                        }
                        if (window.KnifeCustomizationState.setSelectedShape) {
                            window.KnifeCustomizationState.setSelectedShape(null);
                        }
                    } else {
                        if (!bladeFitsHandle(currentBlade, handle)) {
                            window.KnifeCustomizationState.selectedBlade = null;
                            window.KnifeCustomizationState.selectedBladeData = null;
                            window.KnifeCustomizationState.selectedShape = null;
                            if (window.KnifeCustomizationState.setSelectedBlade) {
                                window.KnifeCustomizationState.setSelectedBlade(null);
                            }
                            if (window.KnifeCustomizationState.setSelectedShape) {
                                window.KnifeCustomizationState.setSelectedShape(null);
                            }
                        }
                    }
                }
            }
        }
    }
    
    function handleTooltipClick(e, handle) {
        e.stopPropagation();
        setPopupProduct(handle);
        setPopupOpen(true);
    }
    
    function toggleAccordion() {
        var newExpanded = !expanded;
        if (newExpanded) {
            window.KnifeCustomizationState.activeAccordion = 'handle';
            setActiveAccordion('handle');
        } else {
            window.KnifeCustomizationState.activeAccordion = null;
            setActiveAccordion(null);
        }
        setExpanded(newExpanded);
        
        if (newExpanded && !hasLoadedAll) {
            setLoading(true);
            window.fetchProducts('handles').then(function(data) {
                setAllHandles(data);
                window.KnifeCustomizationState.allHandles = data;
                
                var currentShape = window.KnifeCustomizationState.selectedShape;
                var currentBlade = window.KnifeCustomizationState.selectedBladeData;
                var filtered = filterHandles(data, currentShape, currentBlade);
                setHandleTypes(filtered);
                
                setHasLoadedAll(true);
                setLoading(false);
            }).catch(function() {
                setHandleTypes([]);
                setAllHandles([]);
                setLoading(false);
            });
        }
    }
    
    function handleReset(e) {
        e.stopPropagation();
        setSelectedHandle(null);
        window.KnifeCustomizationState.selectedHandle = null;
        window.KnifeCustomizationState.selectedHandleData = null;
        if (accordionContentRef.current) {
            accordionContentRef.current.scrollTop = 0;
        }
    }
    
    var selectedHandleName = selectedHandle ? (function() {
        var found = handleTypes.find(function(h) { return h.id === selectedHandle; });
        return found ? found.name : null;
    })() : null;
    
    function getHandleImage(handle) {
        return (handle.metafields && handle.metafields['custom.customization_thumbnail']) || handle.image || '';
    }
    
    return React.createElement(React.Fragment, null,
        React.createElement('div', { className: 'knife-accordion' },
            React.createElement('div', { className: 'customization--option-dropdown', onClick: toggleAccordion },
                React.createElement('div', { className: 'customization--option-left' },
                    React.createElement('img', { src: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/Accordion-icon-handle.svg?v=1769763723', loading: 'lazy', width: '174', alt: '', className: 'customization-icon' }),
                    React.createElement('div', { className: 'customization--option-text' }, 'Select Your Handle Type', selectedHandleName && ' - ' + selectedHandleName)
                ),
                React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d5f61874fb14ff18f15d86_customization-icon-right.svg', loading: 'lazy', alt: '', className: 'image' })
            ),
            React.createElement('div', { className: 'accordion-content' + (expanded ? ' expanded' : ''), ref: accordionContentRef },
                React.createElement('div', { className: 'reset-button-container' + (selectedHandle && !loading ? ' visible' : '') },
                    React.createElement('div', { className: 'reset-button-inner' },
                        React.createElement('div', { className: 'reset-button', onClick: handleReset },
                            React.createElement('div', { className: 'reset--button-text' }, 'RESET SELECTION'),
                            React.createElement('img', { src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68d64cf53de35dba15bd1f53_9ca7e0fa65307fe51373378192d8b7ee_reset-icon.svg', loading: 'lazy', width: 'Auto', alt: '', className: 'reset--button-icon' })
                        )
                    )
                ),
                React.createElement('div', { className: 'accordion-grid' },
                    loading ? React.createElement(SkeletonLoader, { count: 4 }) :
                    handleTypes.length === 0 ? 
                        React.createElement('div', { className: 'accordion-empty-state' }, 'No handles available') :
                    handleTypes.map(function(handle) {
                        return React.createElement(ProductCard, {
                            key: handle.id,
                            product: handle,
                            isSelected: selectedHandle === handle.id,
                            onSelect: handleHandleSelect,
                            onTooltipClick: handleTooltipClick,
                            showPrice: true,
                            getImageUrl: getHandleImage
                        });
                    })
                )
            )
        ),
        React.createElement(ProductPopup, { isOpen: popupOpen, onClose: function() { setPopupOpen(false); }, product: popupProduct, imageType: 'handle' })
    );
}

window.KnifeShapeAccordion = KnifeShapeAccordion;
window.BladeTypeAccordion = BladeTypeAccordion;
window.HandleTypeAccordion = HandleTypeAccordion;